function getEnv(env, defaults) {
  return process.env[env] || defaults
}

export default {
  LAYERS_ID_URL: getEnv('VUE_APP_LAYERS_ID_URL', 'http://localhost:8090/'),
  API_URL: getEnv('VUE_APP_API_URL', 'http://localhost:8009/v1'),
  ENV: getEnv('NODE_ENV', 'development')
}